import { render, staticRenderFns } from "./RegionInput.vue?vue&type=template&id=c0a4d1f2&lang=pug"
import script from "./RegionInput.vue?vue&type=script&lang=js"
export * from "./RegionInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports